import React from 'react'
import { Horizontal, Vertical, GraviButton, MaterialIcon, Texto } from '@gravitate-js/excalibrr'
import type { components } from '../../../../../../types/api/v1'

type InvoiceCandidate = components['schemas']['InvoiceCandidate']
type BolCandidate = components['schemas']['BolCandidate']

interface MatchDocumentsState {
  invoices: InvoiceCandidate[]
  bols: BolCandidate[]
}

interface ManageMatchActionBarProps {
  currentMatchDocuments: MatchDocumentsState
  isSaving: boolean
  onSave: () => void
  onCancel: () => void
}

export function ManageMatchActionBar({ currentMatchDocuments, isSaving, onSave, onCancel }: ManageMatchActionBarProps) {
  const totalInvoices = currentMatchDocuments.invoices.length
  const totalBols = currentMatchDocuments.bols.length

  return (
    <Horizontal
      className='px-3 py-2'
      bg='elevated'
      border='top'
      justifyContent='space-between'
      verticalCenter
      style={{
        position: 'sticky',
        bottom: 0,
        zIndex: 10,
      }}
    >
      <Horizontal gap={16} verticalCenter>
        <MaterialIcon icon='link' size={20} />
        <Vertical gap={2}>
          <Texto category='p1' weight='600'>
            Manage Match
          </Texto>
          <Texto category='p3'>
            {totalInvoices} invoice{totalInvoices !== 1 ? 's' : ''}, {totalBols} BOL{totalBols !== 1 ? 's' : ''} in
            match
          </Texto>
        </Vertical>
      </Horizontal>

      <Horizontal gap={12}>
        <GraviButton appearance='outlined' onClick={onCancel}>
          Cancel
        </GraviButton>
        <GraviButton theme2 onClick={onSave} loading={isSaving}>
          Save Changes
        </GraviButton>
      </Horizontal>
    </Horizontal>
  )
}
